/* eslint-disable compat/compat */

// @flow

import { createHttpClient } from '@fil-global/eiswagen';
import jsonp from 'jsonp';
import _get from 'lodash/get';

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
    Accept: 'application/json',
  },
  timeout: 60000,
  withCredentials: true,
};

const axiosClient = createHttpClient(axiosConfig);

// Response interceptors.
export const responseInterceptor = response => response;

export const responseInterceptorError = error => {
  const errorData = _get(error, 'response.data', { message: 'Unexpected error' });
  return Promise.reject(errorData);
};

axiosClient.interceptors.response.use(responseInterceptor, responseInterceptorError);

export const jsonpClient = (url: string, callbackName: string): Promise<any> =>
  new Promise((resolve, reject) => {
    jsonp(url, { name: callbackName }, (error, data) => {
      if (!error) {
        resolve(data);
      } else {
        reject(error);
      }
    });
  });

export default axiosClient;
